module.exports = __webpack_public_path__ + "static/assets/aeaeb7f359d44e636db97e12d5c8c8c4.png";